import axios from 'axios';
import { safeNextPath } from './utils/redirect';

const API_URL = process.env.REACT_APP_API_URL || '';

axios.interceptors.response.use(
  res => res,
  err => {
    // A 401 only means "your session expired" if we actually held a token when
    // the request went out. A 401 with no token in hand is just an anonymous
    // (or un-authenticated) call to a protected endpoint — bouncing to /login
    // there would wipe a perfectly good session and yank the page out from
    // under the caller, so let the caller render its own sign-in prompt.
    if (err.response?.status === 401 && localStorage.getItem('token')) {
      localStorage.removeItem('token');
      localStorage.removeItem('user');
      // Carry where they were, so signing back in returns them to it rather
      // than to a dashboard. A candidate whose session lapses while reading a
      // job otherwise has to find that job again before they can apply.
      const here = safeNextPath(`${window.location.pathname}${window.location.search}`);
      window.location.href = here ? `/login?next=${encodeURIComponent(here)}` : '/login';
    }
    return Promise.reject(err);
  }
);

export default API_URL;
